import React from "react";
import GlobalContext from "../../../contexts/globalContext";
import "./footer-tabs-rates-internal.scss";
//import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
export interface PropsTabsRates {
  tabsSectionRatesData: any;
  activeItem: number;
}
const FooterRatesTabsInternal = (props: PropsTabsRates) => {
  const activeItem = props.activeItem;
  const refContenido = props.tabsSectionRatesData.referenciaTabsContenido;

  return (
    <GlobalContext.Consumer>
      {() => (
        <div>
          <div className="m-tabs-sec-int__details-footer">
            <div className="m-tabs-sec-int__details-footer-phrase">
              <div
                className={`m-tabs-sec-int__details-footer-phrase-internal ${
                  refContenido[activeItem].referenciaTarifas.tituloDescripcion
                    ? "margin-rates"
                    : ""
                }`}
              >
                <div className="blockquoteopen"></div>
                <h4>
                  {
                    refContenido[
                      activeItem
                    ].referenciaTarifas.tituloBanner.split("(")[0]
                  }
                </h4>
                <p>
                  {refContenido[activeItem].referenciaTarifas.tituloBanner
                    .split("(")[1]
                    .slice(
                      0,
                      refContenido[
                        activeItem
                      ]?.referenciaTarifas?.tituloBanner?.split("(")[1]
                        ?.length - 1
                    )}
                </p>
                <p>
                  {/*refContenido[activeItem].referenciaTarifas.tituloBanner
                    .split("(")[1]
                    .slice(
                      0,
                      refContenido[
                        activeItem
                      ]?.referenciaTarifas?.tituloBanner?.split("(")[1]
                        ?.length - 1
                    )*/}
                </p>

                <div className="blockquoteclose"></div>
              </div>
              {/*<div className="m-tabs-sec-int__details-footer-phrase-button">
                {refContenido[activeItem].referenciaTarifas
                  .tituloDescripcion ? (
                  ""
                ) : (
                  <Button
                    text={
                      refContenido[activeItem].referenciaTarifas.tituloBoton
                    }
                    classname={"secondary button-large"}
                    type="button"
                    isDisabled={false}
                    strictCss={false}
                    gtmMark={`gtmRedDeAmorHabitosSaludMentalInternaTarifas${normalizeTwoWords(
                      refContenido[activeItem].nombreTab
                    )}${normalizeTwoWords(
                      refContenido[activeItem].referenciaTarifas.tituloBoton
                    )}`}
                    onClickAction={() => {
                      data.gigyaContext.gigyaAccount
                        ? navigate("/agenda-red-de-amor")
                        : data.gigyaContext.login();
                    }}
                  />
                )}
              </div>
                  */}
            </div>
            <div
              className={`m-tabs-sec-int__details-footer-rates ${
                refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  ? "rates-text"
                  : ""
              }`}
            >
              <h4
                className={`${
                  refContenido[activeItem].referenciaTarifas.tituloDescripcion
                    ? "titulo_rates"
                    : ""
                }`}
              >
                {refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  ? refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  : refContenido[activeItem].referenciaTarifas.descripcion &&
                    JSON.parse(
                      refContenido[activeItem].referenciaTarifas.descripcion.raw
                    ).content[0]?.content[0]?.value}
              </h4>
              <div
                className={`m-tabs-sec-int__details-footer-rates-organization ${
                  refContenido[activeItem].referenciaTarifas.tituloDescripcion
                    ? "organization-text"
                    : ""
                }`}
              >
                {refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  ? ""
                  : refContenido[activeItem].referenciaTarifas.descripcion &&
                    JSON.parse(
                      refContenido[activeItem].referenciaTarifas.descripcion.raw
                    )?.content?.[1]?.content?.map((val, key) => {
                      return (
                        <div
                          className="m-tabs-sec-int__details-footer-rates-bigcard"
                          key={key}
                        >
                          {props.tabsSectionRatesData.nombreCategoria ===
                          "Interna formación" ? (
                            <div className="m-tabs-sec-int__details-footer-rates-minicard">
                              <p>
                                <span>
                                  {val.content?.[0]?.content?.[0]?.value
                                    ? val.content?.[0]?.content?.[0]?.value
                                    : ""}
                                </span>
                                <strong>
                                  {val.content?.[0]?.content?.[1]?.value
                                    ? val.content?.[0]?.content?.[1]?.value
                                    : ""}
                                </strong>
                                {val.content?.[0]?.content?.[2]?.value
                                  ? val.content?.[0]?.content?.[2]?.value
                                  : ""}
                              </p>
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                {refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  ? ""
                  : /*(
                  <div className="free-rate-int">
                    <p className="free-rate-int-text">
                      {refContenido[activeItem].referenciaTarifas.descripcion
                        .raw.content[2]?.content[0]?.value != ""
                        ? refContenido[activeItem].referenciaTarifas.descripcion
                            .raw.content[2]?.content[0]?.value
                        : ""}
                    </p>
                  </div>
                      )*/ null}
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};
export default FooterRatesTabsInternal;
